module.exports = __webpack_public_path__ + "img/05-activation.a95cd492.png";